import React from "react";

export interface EnumTextOption {
  label: string;
  value: number | string;
}

interface EnumTextProps {
  emptyText?: string;
  options: EnumTextOption[];
  value?: number | string | null;
}

const EnumText = ({
  emptyText = "-",
  options,
  value,
}: EnumTextProps): React.ReactElement => {
  const item = options.find((option) => String(option.value) === String(value));

  return <span>{item?.label ?? emptyText}</span>;
};

export default EnumText;
